<template>
    <table class="table table-hover table-bordered" style="width:100%">
        <thead>
        <tr>
            <th>{{ trans.get('account.date') }}</th>
            <th>{{ trans.get('account.type') }}</th>
            <th>{{ trans.get('account.description') }}</th>
            <th>{{ trans.get('account.qty') }}</th>
            <th>{{ trans.get('account.price') }}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="invoice in invoices">
            <tr role="row" class="table-row">
                <td colspan="5" class="table-light"><strong>{{ invoice.invoice_number }}</strong></td>
            </tr>
            <template v-for="line in invoice.order_lines">
                <tr role="row" class="table-row">
                    <td class="">{{ line.product.date | date }}</td>
                    <td class="">{{ trans.get('account.' + (line.product.type ? line.product.type.key : '')) }}</td>
                    <td class="">{{ line.product.name}} - {{ line.ticket_option.name}}</td>
                    <td class="">{{ line.quantity}}</td>
                    <td class="">{{ line.subtotal | priceFormat() | withCurrency(currency)}}</td>
                </tr>
                <tr role="row" class="table-row">
                    <td class="">{{ line.product.date | date }}</td>
                    <td class="">{{ trans.get('account.delivery_method') }}</td>
                    <td class="">{{ invoice.order.delivery_method.name }}</td>
                    <td class="">1</td>
                    <td class="">{{ invoice.order.delivery_method.sale_price | priceFormat() | withCurrency(currency)}}</td>
                </tr>
            </template>
            <tr v-for="line in invoice.order_custom_lines" role="row" class="table-row">
                <td class="">{{ line.product.date | date }}</td>
                <td class="">{{ line.concept}}</td>
                <td class=""> {{ line.description}}</td>
                <td class="">{{ line.quantity}}</td>
                <td class="">{{ line.subtotal | priceFormat() | withCurrency(currency) }}</td>
            </tr>
            <tr role="row" class="table-row table-borderless">
                <td></td>
                <td>{{ trans.get('account.price_adjustment') }}</td>
                <td>{{ invoice.price_adjustment | priceFormat() | withCurrency(currency) }}</td>
                <td>{{ trans.get('account.total') }}</td>
                <td>{{ invoice.price_total | priceFormat() | withCurrency(currency) }}</td>
            </tr>
            <tr role="row" class="table-row table-borderless">
                <td></td>
                <td>{{ trans.get('account.paid_sum') }}</td>
                <td>{{ invoice.paid_sum | priceFormat() | withCurrency(currency) }}</td>
                <td>{{ trans.get('account.sum_left_to_pay') }}</td>
                <td><strong>{{ invoice.sum_left_to_pay | priceFormat() | withCurrency(currency) }}</strong></td>
            </tr>
        </template>
        <tr role="row" class="table-row">
            <td class="table-light"></td>
            <td class="table-light"></td>
            <td class="table-light"></td>
            <td class="table-light"></td>
            <td class="table-light"><strong>{{ (total) | priceFormat() | withCurrency(currency) }}</strong></td>
        </tr>
        </tbody>
    </table>
</template>
<script>
import {mapFields} from 'vuex-map-fields';
import moment from 'moment';

export default {
    name: 'invoice-summary',
    filters: {
        price(value) {
            return window.priceFormat(value)
        },
        date(value) {
            return moment(value).format('YYYY/MM/DD');
        }
    },
    computed: {
        ...mapFields([
            'invoices',
            'total',
            'currency',
            'loading',
        ]),
        isValid() {
            return true;
        },
    },
}
</script>
